import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import SalesSummary from "../../../common/salarySummery";
import TableReport from "../../../common/tableReport";
import {
  getCategorySalesCustomers,
  getCategoryWiseCounterSalesReportXlsx,
} from "../reportsApi";
import dayjs from "dayjs";
import { getFirstDateOfMonth } from "../../../utils/commonUtils";
import axios from "axios";

const data = [
  { category: "Hair Wash", items: 11, amount: "₹ 2443.38", percent: "56.09%" },
  {
    category: "Head Massage",
    items: 21,
    amount: "₹ 2443.38",
    percent: "77.00%",
  },
  { category: "Manicure", items: 1, amount: "₹ 2443.38", percent: "44.00%" },
  {
    category: "Basic Facial",
    items: 3,
    amount: "₹ 2443.38",
    percent: "33.00%",
  },
  { category: "Shaving", items: 4, amount: "₹ 2443.38", percent: "33.00%" },
  {
    category: "Detox Treatment",
    items: 5,
    amount: "₹ 2443.38",
    percent: "33.00%",
  },
  {
    category: "Eyelash Lifting",
    items: 23,
    amount: "₹ 2443.38",
    percent: "44.00%",
  },
];

export default function SalesReport() {
  const [dateValue, setDateValue] = useState(dayjs().format("YYYY-MM-DD"));
  const [displayDate, setDisplayDate] = useState();
  const [categorySale, setCategorySale] = useState(null);
  const [date, setDate] = useState(null);

  const [SelectedStartDate, setSelectedStartDate] = useState(dayjs());
  const [SelectedEndDate, setSelectedEndDate] = useState(dayjs());
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [displayEndDate, setDisplayEndDate] = useState(null);

  const [startDateFormat, setstartDateFormat] = useState(
    dayjs().format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));


  const datePickerOnChange = (newValue) => {
    setSelectedStartDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long",
        day: "2-digit",
      })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDate(formattedDate2);

    // Update startDateFormat for API call
    setstartDateFormat(newValue.format("YYYY-MM-DD"));
    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  const datePickerOnChangeEnd = (newValue) => {
    setSelectedEndDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long",
        day: "2-digit",
      })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDisplayEndDate(formattedDate2);

    // Update endDate for API call
    setEndDate(newValue.format("YYYY-MM-DD"));
    setEndDateOpen(false);
  };
  const salesData = [
    { label: "Total Sale", today: "0.00", monthly: "77801.95" },
    { label: "Counter Sale", today: "0.00", monthly: "77801.95" },
    { label: "Credit Sale", today: "0.00", monthly: "0.00" },
    { label: "Expenses", today: "0.00", monthly: "14000.00" },
    { label: "Number of Bills", today: "0", monthly: "38" },
    { label: "Product Sold", today: "0", monthly: "58" },
    { label: "Service Sold", today: "0", monthly: "26" },
  ];

  const getData = async (param) => {
    await getCategorySalesCustomers(param)
      .then((res) => {
        setCategorySale({
          ...categorySale,
          total: res?.data?.data?.categoryWiseCounterSale,
          totalSales: res?.data?.data?.totalSales,
        });
      })
      .catch((err) => {
        console.log("Category Customer Fetch Error ", err);
      });
  };

  useEffect(() => {
    if (startDateFormat && endDate) {
      getData({
        fromDate: startDateFormat,
        toDate: endDate,
      });
    }
  }, [startDateFormat, endDate]);

  const downloadXLSXFile = async (param) => {
    try {
      // const response = await axios.post(
      //   "user/api/v1/CounterSales/GetCategoryWiseCounterSaleXlsx",
      //   param,
      //   {
      //     responseType: "blob",
      //   }
      // );

      const response = await getCategoryWiseCounterSalesReportXlsx(param, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };

  return (
    <Box sx={{ p: {xs:2, sm:3}, background: "#ede9ff", minHeight: "100vh" }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Box
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              mt: "10px",
              borderRadius: "5px",
              color: "#01008B", // optional text color
              textAlign: "left",
              marginBottom: "8px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "18px" },
              }}
            >
              Item Category Wise Daily Counter Sales
            </Typography>
          </Box>
        </Grid>
        {/* Date Input */}
        <Grid item xs={12} sm={12} md={10}>
          <TextField
            label="Date"
            size="small"
            value={
              SelectedStartDate && SelectedEndDate
                ? `${SelectedStartDate.format(
                    "DD-MM-YYYY"
                  )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                : SelectedStartDate
                ? `${SelectedStartDate.format("DD-MM-YYYY")}`
                : ""
            }
            id="datepickerfield"
            placeholder="Select date range"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <CalendarMonthIcon
                  sx={{
                    cursor: "pointer",
                    mr: 1,
                  }}
                  onClick={() => setStartDateOpen(true)} // trigger open
                />
              ),
              sx: {
                background: "#fff",
                borderRadius: 1,
                cursor: "pointer",
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              },
            }}
            onClick={() => setStartDateOpen(true)} // trigger open
            sx={{
              width: "100%",
              border: "none",
              "& fieldset": { border: "none" },
            }}
          />

          <Box sx={{ position: "relative" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                open={startDateOpen}
                onOpen={() => setStartDateOpen(true)}
                onClose={() => setStartDateOpen(false)}
                value={SelectedStartDate}
                onChange={(val) => {
                  datePickerOnChange(val);
                }}
                maxDate={SelectedEndDate || undefined}
                slotProps={{
                  popper: {
                    placement: "bottom-end",
                    anchorEl: document.querySelector("#datepickerfield"),
                    sx: { zIndex: 1500 },
                  },
                  textField: { style: { display: "none" } },
                }}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                open={endDateOpen}
                onOpen={() => setEndDateOpen(true)}
                onClose={() => setEndDateOpen(false)}
                value={SelectedEndDate}
                onChange={(val) => {
                  datePickerOnChangeEnd(val);
                }}
                minDate={SelectedStartDate || undefined}
                slotProps={{
                  popper: {
                    placement: "bottom-start",
                    anchorEl: document.querySelector("#datepickerfield"),
                    sx: { zIndex: 1500 },
                  },
                  textField: { style: { display: "none" } },
                }}
              />
            </LocalizationProvider>
          </Box>
        </Grid>

        {/* Download Button */}
        <Grid item md={2} xs={12}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              downloadXLSXFile({
                fromDate: startDateFormat,
                toDate: endDate,
              });
            }}
            sx={{
              height: "40px",
              backgroundColor: "#14008B",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
            endIcon={<DownloadIcon />}
          >
            Download
          </Button>
        </Grid>

        {/* Total Sale */}
        <Grid xs={12}>
          <Grid
            container
            //  my={1}
            sx={{
              padding: "20px",
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={"auto"}
              sx={{
                padding: "8px 16px",
                margin: "8px 8px 0px 0",
                fontWeight: "500",
                backgroundColor: "#CCCCFF",
                borderRadius: "8px",
              }}
            >
              <Typography
                component="p"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "5px",
                  color: "#00008B",
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Total Sale:&nbsp;&nbsp;&nbsp;
                </Typography>
                <Typography
                  component="span"
                  sx={{
                    fontWeight: "bold",
                    marginLeft: "8px",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {categorySale?.totalSales}
                </Typography>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Table */}
      <Box sx={{ borderRadius: 2, background: "#fff" }}>
        <TableReport data={categorySale?.total} />
      </Box>
    </Box>
  );
}
